export default {
    pdf: 'pdf',
    file: 'file'
}